import { useQueryClient } from '@tanstack/react-query';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Menu from '@mui/icons-material/Menu';
import Close from '@mui/icons-material/Close';
import { Box, Typography } from '@mui/material';
import Button from '~/components/Commons/Button';
import logo from '~/assets/img/header_logo.png';
import { PageLoadingIndicator } from '../PageLoadingIndicator/PageLoadingIndicator';
import CustomLink from '../Link/Link';

interface MobileNavBarProps {
  activeRoute?: string | null;
  handleDrawerToggle?: () => void;
  mobileNavOpen?: boolean;
  isAuthBar?: boolean;
}

function MobileNavBar({
  activeRoute = null,
  handleDrawerToggle,
  mobileNavOpen = false,
  isAuthBar = false,
}: MobileNavBarProps) {
  const queryClient = useQueryClient();

  return (
    <Box sx={{ '& header': { paddingRight: '0px !important' } }}>
      <PageLoadingIndicator />
      <AppBar
        sx={{
          position: 'relative',
          backgroundColor: 'dianomiGrey.main',
          borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
          boxShadow: 'none',
          color: 'inherit',
        }}
      >
        <Toolbar
          sx={{
            padding: '0 8px',
            minHeight: '56px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          {!isAuthBar ? (
            <>
              <Button
                sx={{
                  minWidth: '44px',
                  width: '44px',
                  height: '44px',
                  padding: 0,
                  borderRadius: '8px',
                  color: '#333',
                  '&:hover': {
                    backgroundColor: 'rgba(0, 0, 0, 0.04)',
                  },
                }}
                aria-label={mobileNavOpen ? 'close menu' : 'open menu'}
                onClick={handleDrawerToggle}
              >
                {mobileNavOpen ? <Close /> : <Menu />}
              </Button>
              <Box sx={{ flex: 1, display: 'flex', justifyContent: 'center', px: 1 }}>
                <Typography
                  variant="h1"
                  sx={{
                    fontSize: '16px',
                    fontWeight: 600,
                    letterSpacing: '-0.01em',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    color: '#1a1a1a',
                  }}
                >
                  {activeRoute}
                </Typography>
              </Box>
              <Box sx={{ width: '44px' }} />
            </>
          ) : (
            <Box sx={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
              <CustomLink to="/" onClick={() => queryClient.clear()}>
                <img
                  src={logo}
                  alt="Dianomi"
                  style={{
                    height: '32px',
                    width: 'auto',
                    filter: 'invert(1)',
                  }}
                />
              </CustomLink>
            </Box>
          )}
        </Toolbar>
      </AppBar>
    </Box>
  );
}

export default MobileNavBar;
